<div class="container pt-3 pb-1 h-full overflow-auto">
  <div class="jumbotron">
    <h1 class="display-4">{{ 'VIEWS.CONFIG_LACKS.TITLE' | translate }}</h1>
    <p
      class="lead"
      [innerHTML]="'VIEWS.CONFIG_LACKS.DESCRIPTION' | translate"
    ></p>
  </div>
</div>
